import { useNavigate } from "react-router-dom";
import { IoArrowBackSharp } from "react-icons/io5";
import Layout from "Reusable/Parent/layout";
import BatchContact from "Pages/Parent/Home/Homepage/BatchContact/BatchContact";
import styles from "./HelpSupport.module.scss";

const HelpSupport = () => {
    const navigate = useNavigate();

    return (
        <Layout>
            <div className={styles["Container"]}>
                <button
                    className={styles["back-btn"]}
                    onClick={() => navigate(-1)}>
                    <IoArrowBackSharp /> Back
                </button>
                <BatchContact autoExpand />
            </div>
        </Layout>
    );
};

export default HelpSupport;
